import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-toomany-fav',
    templateUrl: './toomany-fav.component.html',
    styleUrls: ['./toomany-fav.component.scss']
})
export class ToomanyFavComponent implements OnInit {

    plan: string = "";

    constructor(
        public dialogRef: MatDialogRef<ToomanyFavComponent>,
        private trackingService: TrackingService,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.plan = data.plan;
    }

    ngOnInit(): void {
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.trackingService.click('upgrade_plan_favorite_valid', this.plan);
        this.router.navigate(['/app/user/plan']);
        this.dialogRef.close(true);
    }
}
